export function SignupProgress({ step }: { step: number }) {
  return (
    <>
      <div className="flow-topline">
        <span>CLASS SIGNUP</span>
        <span>0{step + 1} / 02</span>
      </div>
      <div className="progress">
        <i style={{ width: `${(step + 1) * 50}%` }} />
      </div>
    </>
  )
}
